// eslint-disable-next-line import/prefer-default-export
export const testAttributes = {
    DISCLOSURETOOLTIP_MAIN_CONTAINER: 'disclosuretooltip_main_container',
    DISCLOSURECONTENT_CONTAINER: 'disclosurecontent_container',
};
export const defaultAttributes = {
    CONTENT_TITLE: 'Fact-checked',
    TARGET_TITLE: 'FACT-CHECKED',
};
